import SSEConstant from '../const/SSEConstant'
import { isnull, localSave } from '../../utils/tools'
import { loge, log } from '../../utils/devext'
import EventBusConstant from '../const/EventBusConstant'
import global from '../../config/global'
import StatisticsHelper from "../../utils/StatisticsUtils";

export default class SSEPushListener {
  constructor(vueObj) {
    this.pageTarget = vueObj
  }

  onReceivePush(pushRsp) {
    this.commonOperation(pushRsp.subCode)
    switch (pushRsp.subCode) {
      case SSEConstant.OpPush.addDiamond:            // 后台加钻石
        let diamond = pushRsp.data.leftDiamond
        let svip = pushRsp.data.isSVip
        this.pageTarget.$globalAppCfg.addCoins(diamond)
        StatisticsHelper.purchase_suc(pushRsp.data.priceUSD, pushRsp.data.productId)
        this.pageTarget.$EventBus.$emit(global.pay_res_event_success, svip, diamond, pushRsp.data.accountId)
        break
      case SSEConstant.OpPush.anchorPutOnMic:            // 主播上麦
        this.onReceiveAnchorPutOnMic(pushRsp)
        break;
      case SSEConstant.OpPush.anchorPutOffMic:           // 主播下麦
        this.onReceiveAnchorPutOffMic(pushRsp)
        break;
      case SSEConstant.OpPush.bossPutOnMic:              // 老板上麦
        this.onReceiveBossPuOnMic(pushRsp)
        break;
      case SSEConstant.OpPush.bossPutOffMic:             // 老板下麦
        this.onReceiveBossPuOffMic(pushRsp)
        break;
      case SSEConstant.OpPush.hostBanAnchorMic:          // 主持人禁言主播, boss
        this.onReceiveHostBanAnchor(pushRsp)
        break;
      case SSEConstant.OpPush.hostUnbanAnchorMic:        // 主持人解禁主播, boss
        this.onReceiveHostUnBanAnchor(pushRsp)
        break;
      case SSEConstant.OpPush.hostEditRoom:              // 主持人编辑房间
        this.onReceiveHostEditRoom(pushRsp)
        break;
      case SSEConstant.OpPush.anchorOnMicTimeUp:         // 主播上麦300秒倒计时结束
        this.onReceiveAnchorOnMicTimeUp(pushRsp)
        break;
      case SSEConstant.OpPush.hostBanMemberText:         // 主持人禁止成员发文字消息
        this.onHostBanMemberText(pushRsp)
        break;
      case SSEConstant.OpPush.hostForceAnchorPutOffMic:  // 主持人强制主播下麦
        this.onReceiveAnchorPutOffMic(pushRsp)
        break;
      case SSEConstant.OpPush.VoiceChatRoomEnter:            // 语聊进场动画
        this.onReceiveEnterEffect(pushRsp)
        break;
      case SSEConstant.OpPush.VideoRoomEnter:            // 直播进场动画
        this.onReceiveEnterEffect(pushRsp)
        break;
      case SSEConstant.OpPush.receiveTextMsg:            // 收到文字消息
        this.onReceiveTextMsg(pushRsp)
        break;
      case SSEConstant.OpPush.perfectMatch:              // 配对成功
        this.onPerfectMatch(pushRsp)
        break;
      case SSEConstant.OpPush.roomMemberCountUpdated:    // 语聊房人数变化
        this.onReceiveMultiMemberUpdate(pushRsp)
        break;
      case SSEConstant.OpPush.openVoiceChatRoom:         // 开启语聊房功能
        global.setVoiceChatOn(true)
        break;
      case SSEConstant.OpPush.closeVoiceChatRoom:        // 关闭语聊房功能
        global.setVoiceChatOn(false)
        break;
      case SSEConstant.OpPush.hostForceBossPutOffMic:    // 主持人强制boss下麦
        this.onReceiveForcePutOffBoss(pushRsp)
        break;
      case SSEConstant.OpPush.kickedOut:                 // 被挤下线
        this.pageTarget.$EventBus.$emit(global.KICKED_OFF)
        break
      case SSEConstant.OpPush.MultiRoomDestroy:          // 语聊房间解散
        this.onReceiveMultiRoomDestroy(pushRsp)
        break;
      case SSEConstant.OpPush.MultiRoomCreate:           // 新语聊房创建
        this.onReceiveMultiRoomCreate(pushRsp)
        break;
      case SSEConstant.OpPush.MultiRoomClose:            // 有语聊房关闭
        this.onReceiveMultiRoomClose(pushRsp)
        break;
      case SSEConstant.OpPush.OpenVideoFeature:          // 开放视频聊天室功能【用来动态调整首页标签顺序】
        global.setVideoChatOn(true)
        break;
      case SSEConstant.OpPush.CloseVideoFeature:         // 关闭视频聊天室功能【用来动态调整首页标签顺序】
        global.setVideoChatOn(false)
        break;
      case SSEConstant.OpPush.VideoRoomClose:            // 老视频聊天室关闭
        this.onReceiveVideoRoomClose(pushRsp)
        break
      case SSEConstant.OpPush.VideoRoomCreate:           // 新视频聊天室开启
        this.onReceiveVideoRoomCreate(pushRsp)
        break
      case SSEConstant.OpPush.VideoRoomResume:           // 视频聊天室恢复
        this.onReceiveVideoRoomResume(pushRsp)
        break
      case SSEConstant.OpPush.VideoRoomDestroy:          // 视频聊天室解散
        this.onReceiveVideoRoomDestroy(pushRsp)
        break
      case SSEConstant.OpPush.VideoRoomPrivateChatFlagChange:    // 视频聊天室私聊开关改变
        this.onReceiveVideoRoomPrivateFlagChange(pushRsp)
        break;
      case SSEConstant.OpPush.VideoRoomHostIsTaken:      // 视频聊天室主持人被带走
        this.onReceiveVideoRoomHostIsTaken(pushRsp)
        break
      case SSEConstant.OpPush.MultiOnMicTimeUpdate:      // 主播麦位倒计时改变
        this.onReceiveMultiAnchorTimeUpdate(pushRsp)
        break;
      case SSEConstant.OpPush.VoiceChatRoomGoalUpdated:
      case SSEConstant.OpPush.VideoChatRoomGoalUpdated:   // 目标数据更新
        this.onReceiveRoomGoalUpdated(pushRsp)
        break
      case SSEConstant.OpPush.VoiceChatRoomGoalDone:
      case SSEConstant.OpPush.VideoChatRoomGoalDone:   // 目标达成
        this.onReceiveRoomGoaldone(pushRsp)
        break
      case SSEConstant.OpPush.VoiceHostWarnMember:   // 目标达成
        this.onReceiveWarnMsg(pushRsp)
        break
    }
  }


  /**
   * 主播上麦300秒倒计时结束
   * LiMeAnchorPutOffMicMsg
   *  var anchorAccountId: Int = -1
   *  var roomId: Int = -1
   *  var seatNumber: Int = -1
   * @param pushRsp
   */
  onReceiveAnchorOnMicTimeUp(pushRsp) {
    log('onReceiveAnchorOnMicTimeUp', "收到 onReceiveAnchorOnMicTimeUp" + pushRsp)
    let LiMeAnchorPutOffMicMsg = null
    try {
      LiMeAnchorPutOffMicMsg = pushRsp.data
    } catch (e) {
    }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_ANCHOR_ON_MIC_TIME_UP, pushRsp.retCode, LiMeAnchorPutOffMicMsg)
  }

  /**
   * 主持人禁止成员发文字消息
   * LiMeMultiBanTextMsg
   *    var accountId = 0
   *    var roomId = 0
   */
  onHostBanMemberText(pushRsp) {
    log('onHostBanMemberText', "收到 onHostBanMemberText" + pushRsp.retCode)
    var LiMeMultiBanTextMsg = null
    try {
      LiMeMultiBanTextMsg = pushRsp.data
    } catch (e) {

    }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_MULTI_BAN_TEXT_MSG, pushRsp.retCode, LiMeMultiBanTextMsg)
  }

  /**
   *  老板上麦
   * @param pushRsp
   * LiMeBossPutOnMicMsg
   *     var roomId: Int = -1
   *     var boss: LiMeMultiBoss? = null
   var bossAccountId = 0
   var bossDisplayAccountId: String? = null
   var avatar: String? = null
   var name: String? = null
   var memberStatus = 0    // 成员状态（1：加入 2：离开 3：上麦 4：下麦 5：禁言 6：关麦）

   constructor(accountId: Int): this() {
                      bossAccountId = accountId
                  }

   fun hasBoss() = bossAccountId != 0

   fun onMic() = memberStatus == 3 || memberStatus == 5 || memberStatus == 6

   //替换信息
   fun replaceData(boss: LiMeMultiBoss) {
                      this.bossAccountId = boss.bossAccountId
                      this.bossDisplayAccountId = boss.bossDisplayAccountId
                      this.avatar = boss.avatar
                      this.name = boss.name
                      this.memberStatus = boss.memberStatus
                  }
   */
  onReceiveBossPuOnMic(pushRsp) {
    log('onReceiveBossPuOnMic', "收到 onReceiveBossPuOnMic " + pushRsp)
    var LiMeBossPutOnMicMsg = null
    try {
      LiMeBossPutOnMicMsg = pushRsp.data
    } catch (e) {
    }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_BOSS_PUT_ON_MIC, pushRsp.retCode, LiMeBossPutOnMicMsg)
  }

  //
  /**
   * 主持人禁言主播, boss
   * @param pushRsp
   * LiMeMultiHostBanMsg
   *   var accountId = 0
   *   var roomId = 0
   */
  onReceiveHostBanAnchor(pushRsp) {
    log('onReceiveHostBanAnchor', "收到 onReceiveHostBanAnchor " + pushRsp)
    var LiMeMultiHostBanMsg = null
    try {
      LiMeMultiHostBanMsg = pushRsp.data
    } catch (e) {
    }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_HOST_BAN_ANCHOR_BOSS, pushRsp.retCode, LiMeMultiHostBanMsg)
  }

  /**
   *   主持人解禁主播, boss
   */
  onReceiveHostUnBanAnchor(pushRsp) {
    log('onReceiveHostUnBanAnchor', "收到 onReceiveHostUnBanAnchor, boss " + pushRsp)
    var LiMeMultiHostBanMsg = null
    try {
      LiMeMultiHostBanMsg = pushRsp.data
    } catch (e) {
    }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_HOST_UNBAN_ANCHOR_BOSS, pushRsp.retCode, LiMeMultiHostBanMsg)
  }

  //
  /**
   * 主持人编辑房间
   * @param pushRsp
   * LiMeMultiData
   var roomId = 0
   var roomTitle: String? = null
   var roomCover: String? = null
   var roomGifCorver: String? = null
   var hostAccountId = 0
   var hostDisplayAccountId: String? = null
   var hostName: String? = null
   var hostFollowersBeg = 0
   var hostFollowersEnd = 0
   var memberCount = 0
   var maxMemberCount = 0
   var pairGifts = 0
   var hostReceivedGifts = 0
   var hostIncome = 0
   var liveDuration = 0
   var roomType = 0
   var anchorList: AnchorList? = null
   var boss: LiMeMultiBoss? = null
   var host: LiMeMultiHost? = null
   var isHostFollowed = false
   var userAvatars: List<String>? = null
   var anchoRAvatars: List<String>? = null
   var roomLiveType = 0
   var roomBackground: String? = null

   var isDestroy = false

   var roomGoal: MultiPlayerChatRoomGoal? = null

   var gifts: List<RoomGiftConfigsData>? = null
   var members:List<LiMeMember>?=null
   class AnchorList: TopData() {
              var anchor: List<LiMeMultiAnchor>? = null
              override fun toString(): String {
                  return "AnchorList(anchor=$anchor)"
              }

          }

   override fun toString(): String {
              return GsonUtils.toJson(this)
          }

   */
  onReceiveHostEditRoom(pushRsp) {
    log('onReceiveHostEditRoom', "收到 onReceiveHostEditRoom " + pushRsp)
    var LiMeMultiData = null
    try {
      LiMeMultiData = pushRsp.data
    } catch (e) {
    }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_HOST_EDIT_ROOM, pushRsp.retCode, LiMeMultiData)
  }

  /**
   * 老板下麦
   * LiMeBossPutOffMicMsg
   *    var anchorAccountId: Int = -1
   *    var roomId: Int = -1
   *    var seatNumber: Int = -1
   */
  onReceiveBossPuOffMic(pushRsp) {
    log('onReceiveBossPuOffMic', "收到 onReceiveBossPuOffMic ${pushRsp.retCode}")
    var LiMeBossPutOffMicMsg = null
    try {
      LiMeBossPutOffMicMsg = pushRsp.data
    } catch (e) {
    }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_BOSS_PUT_OFF_MIC, pushRsp.retCode, LiMeBossPutOffMicMsg)
  }

  /**
   * 主播上麦
   * @param pushRsp
   * LiMeAnchorPutOnMicMsg
   *  var anchor:LiMeMultiAnchor
   var anchorAccountId = 0
   var anchorDisplayAccountId: String? = null
   var avatar: String? = null
   var seatNumber: Int = -1
   var name: String? = null
   var leftOnMicTime: Int = 0
   var memberStatus = 0        // 1：加入 2：离开 3：上麦 4：下麦 5：禁言 6：关麦
   var anchorMood: String? = null
   var isHost = false          // 自定义的字段，是否是主持人，在礼物弹窗里面有用

   constructor(seatNumber: Int): this() {
                  this.seatNumber = seatNumber
              }

   constructor(seatNumber: Int, anchorAccountId: Int): this() {
                  this.seatNumber = seatNumber
                  this.anchorAccountId = anchorAccountId
              }

   constructor(anchor: LiMeMultiHost): this() {
                  isHost = true
                  anchorAccountId = anchor.anchorAccountId
                  anchorDisplayAccountId = anchor.anchorDisplayAccountId
                  avatar = anchor.avatar
                  name = anchor.name
                  memberStatus = anchor.memberStatus
              }

   companion object {
                  fun copy(anchor: LiMeMultiAnchor): LiMeMultiAnchor {
                      return LiMeMultiAnchor().apply {
                          anchorAccountId = anchor.anchorAccountId
                          anchorDisplayAccountId = anchor.anchorDisplayAccountId
                          avatar = anchor.avatar
                          seatNumber = anchor.seatNumber
                          name = anchor.name
                          leftOnMicTime = anchor.leftOnMicTime
                          memberStatus = anchor.memberStatus
                          anchorMood = anchor.anchorMood
                          isHost = anchor.isHost
                      }
                  }
              }

   fun hasAnchor() = anchorAccountId != 0

   fun onMic() = memberStatus == 3 || memberStatus == 5 || memberStatus == 6

   fun replaceData(anchor: LiMeMultiAnchor) {
              anchorAccountId = anchor.anchorAccountId
              anchorDisplayAccountId = anchor.anchorDisplayAccountId
              avatar = anchor.avatar
              seatNumber = anchor.seatNumber
              name = anchor.name
              leftOnMicTime = anchor.leftOnMicTime
              memberStatus = anchor.memberStatus
              anchorMood = anchor.anchorMood
            }

   override fun toString(): String {
              return "LiMeMultiAnchor(anchorAccountId=$anchorAccountId, anchorDisplayAccountId=$anchorDisplayAccountId, avatar=$avatar, seatNumber=$seatNumber, name=$name, leftOnMicTime=$leftOnMicTime, memberStatus=$memberStatus, anchorMood=$anchorMood)"
            }
   */
  onReceiveEnterEffect(pushRsp) {
    var msg = null
    try {
      msg = pushRsp.data
    } catch (e) {
    }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_ENTER_EFFECT, pushRsp.retCode, msg)

  }
  onReceiveAnchorPutOnMic(pushRsp) {
    log('onReceiveAnchorPutOnMic', "收到 onReceiveAnchorPutOnMic " + pushRsp)
    var LiMeAnchorPutOnMicMsg = null
    try {
      LiMeAnchorPutOnMicMsg = pushRsp.data
    } catch (e) {
    }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_ANCHOR_PUT_ON_MIC, pushRsp.retCode, LiMeAnchorPutOnMicMsg)
  }

  /**
   * 主播下麦
   * @param pushRsp
   * LiMeAnchorPutOffMicMsg
   var anchorAccountId: Int = -1
   var roomId: Int = -1
   var seatNumber: Int = -1
   */
  onReceiveAnchorPutOffMic(pushRsp) {
    log('onReceiveAnchorPutOffMic', "收到 onReceiveAnchorPutOffMic" + pushRsp)
    var LiMeAnchorPutOffMicMsg = null
    try {
      LiMeAnchorPutOffMicMsg = pushRsp.data
    } catch (e) {
    }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_ANCHOR_PUT_OFF_MIC, pushRsp.retCode, LiMeAnchorPutOffMicMsg)
  }

  /**
   * 配对成功，所有人都收得到
   * @param pushRsp
   * LiMeMultiPerfectMatchData
   var userId = 0
   var userName: String? = null
   var userAvatar: String? = null

   var anchorId = 0
   var anchorName: String? = null
   var anchorAvatar: String? = null

   var roomId = 0
   */
  onPerfectMatch(pushRsp) {
    log('onPerfectMatch', "收到 onPerfectMatch" + pushRsp)
    var LiMeMultiPerfectMatchData = null
    try {
      LiMeMultiPerfectMatchData = pushRsp.data
    } catch (e) {
    }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_MULTI_PERFECT_MATCH, pushRsp.retCode, LiMeMultiPerfectMatchData)
  }

  /**
   * 收到文字消息
   * @param pushRsp
   * LiMeMultiTextMsg
   *     var roomId = -1
   *     var content: String? = null
   */
  onReceiveTextMsg(pushRsp) {
    log('onReceiveTextMsg', "收到 onReceiveTextMsg " + JSON.stringify(pushRsp))
    var LiMeMultiTextMsg = null
    try {
      LiMeMultiTextMsg = pushRsp.data
    } catch (e) {
    }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_RECEIVE_TEXT_MSG, pushRsp.retCode, LiMeMultiTextMsg)
  }

  /**
   * 语聊房人数变化
   * @param pushRsp
   * LiMeMultiMemberUpdateMsg
   *      var roomId = -1
   var memberCount = -1
   var userAvatars: List<String>? = null
   var hostFollowers = 0
   var members:List<LiMeMember>?=null
   var accountId = 0
   var displayAccountId: String? = null
   var roleType = 0
   get() {
                          return if (field == 1) PP_Constants.UserType.USER
                          else PP_Constants.UserType.ANCHOR
                      }
   var avatar: String? = null
   var nickName: String? = null
   var giftCost = 0
   var commentUp = 0
   var age = 0
   var gender: String? = null

   // 存储本地默认头像
   var avatarRes: Int = 0

   constructor(personData: PP_PersonData): this() {
                      accountId = personData.accountId
                      displayAccountId = personData.displayAccountId
                      roleType = personData.userType
                      avatar = personData.avatar
                      nickName = personData.nickName
                      commentUp = personData.commentUp
                      age = personData.age
                      gender = personData.gender
                  }
   */
  onReceiveMultiMemberUpdate(pushRsp) {
    log('onReceiveMultiMemberUpdate', "收到 onReceiveMultiMemberUpdate" + pushRsp)
    var LiMeMultiMemberUpdateMsg = null
    try {
      LiMeMultiMemberUpdateMsg = pushRsp.data
    } catch (e) {
    }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_MULTI_MEMBER_UPDATE, pushRsp.retCode, LiMeMultiMemberUpdateMsg)
  }

  /**
   * 主持人强制boss下麦
   * @param pushRsp
   */
  onReceiveForcePutOffBoss(pushRsp) {
    log('onReceiveForcePutOffBoss', "收到主 onReceiveForcePutOffBoss " + pushRsp)
    var LiMeBossPutOffMicMsg = null
    try {
      LiMeBossPutOffMicMsg = pushRsp.data
    } catch (e) {
    }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_FORCE_BOSS_PUT_OFF_MIC, pushRsp.retCode, LiMeBossPutOffMicMsg)
  }

  /**
   * 语聊房间解散
   * @param pushRsp
   */
  onReceiveMultiRoomDestroy(pushRsp) {
    log('onReceiveMultiRoomDestroy', "收到 onReceiveMultiRoomDestroy " + pushRsp)
    if (!isnull(pushRsp.data)) {
      let LiMeMultiData = pushRsp.data
      this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_LI_ME_MULTI_DESTROY, pushRsp.retCode, LiMeMultiData)
    }
  }

  /**
   * 新语聊房创建
   * @param pushRsp
   */
  onReceiveMultiRoomCreate(pushRsp) {
    log('onReceiveMultiRoomCreate', "收到 onReceiveMultiRoomCreate " + pushRsp)
    if (!isnull(pushRsp.data)) {
      let LiMeMultiData = pushRsp.data
      this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_LI_ME_MULTI_CREATE, pushRsp.retCode, LiMeMultiData)
    }
  }

  /**
   * 语聊房关闭
   * @param pushRsp
   */
  onReceiveMultiRoomClose(pushRsp) {
    log('onReceiveMultiRoomClose', "收到 onReceiveMultiRoomCreate " + pushRsp)
    if (!isnull(pushRsp.data)) {
      let LiMeMultiData = pushRsp.data
      this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_LI_ME_MULTI_CLOSE, pushRsp.retCode, LiMeMultiData)
    }
  }

  // 老视频聊天室关闭
  /**
   *
   * @param pushRsp
   */
  onReceiveVideoRoomClose(pushRsp) {
    log('onReceiveVideoRoomClose', '收到 onReceiveVideoRoomClose:' + pushRsp)
    if (!isnull(pushRsp.data)) {
      try {
        let videoData = pushRsp.data
        this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_LI_ME_VIDEO_CLOSE, videoData)
      } catch (e) {
        loge('onReceiveVideoRoomClose', e.toString())
      }
    }
  }

  // 新视频聊天室开启
  onReceiveVideoRoomCreate(pushRsp) {
    log('onReceiveVideoRoomCreate', '收到 onReceiveVideoRoomCreate :' + pushRsp)
    if (!isnull(pushRsp.data)) {
      try {
        let videoData = pushRsp.data
        this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_LI_ME_VIDEO_CREATE, videoData)
      } catch (e) {
        loge('onReceiveVideoRoomCreate', e.toString())
      }
    }

  }

  // 视频聊天室恢复
  onReceiveVideoRoomResume(pushRsp) {
    log('onReceiveVideoRoomResume', '收到 onReceiveVideoRoomResume :' + pushRsp)
    if (!isnull(pushRsp.data)) {
      try {
        let videoData = pushRsp.data
        this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_LI_ME_VIDEO_RESUME, videoData)
      } catch (e) {
        loge('onReceiveVideoRoomResume', e.toString())
      }
    }
  }

  // 视频聊天室解散
  onReceiveVideoRoomDestroy(pushRsp) {
    log('onReceiveVideoRoomDestroy', '收到 onReceiveVideoRoomDestroy :' + pushRsp)
    if (!isnull(pushRsp.data)) {
      try {
        let videoData = pushRsp.data
        this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_LI_ME_VIDEO_DESTROY, videoData)
      } catch (e) {
        loge('onReceiveVideoRoomDestroy', e.toString())
      }
    }
  }

  // 视频聊天室私聊开关改变
  onReceiveVideoRoomPrivateFlagChange(pushRsp) {
    log('onReceiveVideoRoomPrivateFlagChange', '收到 onReceiveVideoRoomPrivateFlagChange :' + pushRsp)
    if (!isnull(pushRsp.data)) {
      try {
        let LiMeVideoPrivateFlagChangeMsg = pushRsp.data
        this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_LI_ME_VIDEO_PRIVATE_FLAG_CHANGE, pushRsp.retCode, LiMeVideoPrivateFlagChangeMsg)
      } catch (e) {
        loge('onReceiveVideoRoomHostIsTaken', e.toString())
      }
    }
  }

  // 视频聊天室主持人被带走
  onReceiveVideoRoomHostIsTaken(pushRsp) {
    log('onReceiveVideoRoomHostIsTaken', '收到 onReceiveVideoRoomHostIsTaken :' + pushRsp)
    if (!isnull(pushRsp.data)) {
      try {
        let MultiPerfectMatchData = pushRsp.data
        this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_LI_ME_VIDEO_HOST_IS_TAKEN, MultiPerfectMatchData)
      } catch (e) {
        loge('onReceiveVideoRoomHostIsTaken', e.toString())
      }
    }
  }

  /**
   * 主播麦位倒计时改变
   * @param pushRsp
   * LiMeMultiAnchorMicTimeUpdateMsg
   */
  onReceiveMultiAnchorTimeUpdate(pushRsp) {
    log('onReceiveMultiAnchorTimeUpdate', "收到 onReceiveMultiAnchorTimeUpdate ${pushRsp.retCode}")
    var LiMeMultiAnchorMicTimeUpdateMsg = null
    try {
      LiMeMultiAnchorMicTimeUpdateMsg = pushRsp.data
    } catch (e) {
    }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_ANCHOR_ON_MIC_TIME_UPDATE, pushRsp.retCode, LiMeMultiAnchorMicTimeUpdateMsg)
  }

  //目标数据更新
  onReceiveRoomGoalUpdated(pushRsp) {
    log('onReceiveRoomGoalUpdated', 'doVoiceChatRoomGoalUpdated ---' + pushRsp.data)
    if (!isnull(pushRsp.data)) {
      try {
        let MultiPlayerChatRoomGoal = pushRsp.data
        this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_UPDATE_ROOMGOL, pushRsp.retCode, MultiPlayerChatRoomGoal)
      } catch (e) {
        loge('onReceiveRoomGoalUpdated', e.toString())
      }
    }
  }

  //目标数据完成
  onReceiveRoomGoaldone(pushRsp) {
    log('onReceiveRoomGoaldone', 'doVoiceChatRoomGoalUpddone--- ${pushRsp.retCode}' + pushRsp.data.toString())
    if (!isnull(pushRsp.data)) {
      try {
        let MultiPlayerChatRoomGoal = pushRsp.data
        this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_DONE_ROOMGOL, pushRsp.retCode, MultiPlayerChatRoomGoal)
      } catch (e) {
        loge('onReceiveRoomGoaldone', e.toString())
      }
    }
  }

  //收到警告信息
  onReceiveWarnMsg(pushRsp) {
    log('onReceiveWarnMsg', 'onReceiveWarnMsg--- ${pushRsp.retCode}' + pushRsp.data.toString())
    if (!isnull(pushRsp.data)) {
      try {
        let LimeMultiWarnMsg = JSON.parse(pushRsp.data)
        this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_RECIVE_HOST_WARN, LimeMultiWarnMsg)
      } catch (e) {
        loge('onReceiveWarnMsg', e.toString())
      }
    }

  }

  commonOperation(opCode) {
    switch (opCode) {
      case SSEConstant.OpPush.MultiRoomCreate:
      case SSEConstant.OpPush.MultiRoomClose:
      case SSEConstant.OpPush.MultiRoomDestroy:
      case SSEConstant.OpPush.VideoRoomClose:
      case SSEConstant.OpPush.VideoRoomDestroy:
      case SSEConstant.OpPush.VideoRoomCreate:
        localSave(global.key.RELOAD_ROOM_LIST, true)
        this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_REFRESH_ROOM_LIST)
        break
    }
  }

}



// WEBPACK FOOTER //
// ./src/push/listener/SSEPushListener.js